export class User {
  login_id: string;
  name: string;
  role: string;
  curriculum_id: string;
  birthday: string;
  school_id: string;
  password: string;
  curriculums: Curriculum[] = [];
  school_subjects: SchoolSubject[] = [];

  constructor(curriculums: any[], schoolSubjects: any[]){
    curriculums.forEach((x: any) => {
      this.curriculums.push(new Curriculum(x, false));
    });
    schoolSubjects.forEach((x: any) => {
      this.school_subjects.push(new SchoolSubject(x, false));
    });
  }
}

export class Curriculum {
  id: number
  name: string
  is_selected: boolean

  constructor(curriculum: any, is_selected: boolean){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.is_selected = is_selected;
  }
}

export class SchoolSubject {
  subject_code: number
  name: string
  is_selected: boolean

  constructor(x: any, is_selected: boolean){
    this.subject_code = x.subject_code;
    this.name = x.name;
    this.is_selected = is_selected;
  }
}